import * as React from 'react';
const OfficeIcon = ({ fill = 'black', ...props }) => (
    <svg width={19} height={15} viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M16.4516 14V3H12.9263V0H2.35023V14H0V15H8.22581V12H10.576V15H18.8018V14H16.4516ZM7.05069 10H4.70046V8H7.05069V10ZM7.05069 7H4.70046V5H7.05069V7ZM7.05069 4H4.70046V2H7.05069V4ZM10.576 10H8.22581V8H10.576V10ZM10.576 7H8.22581V5H10.576V7ZM10.576 4H8.22581V2H10.576V4ZM15.2765 10H12.9263V8H15.2765V10ZM15.2765 7H12.9263V5H15.2765V7Z"
            fill={fill}
        />
    </svg>
);
export default OfficeIcon;
